import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SharedCryptoSelectOption } from "@/shared/constants/constants";

const FIAT_CURRENCY_SYMBOLS: Record<string, string> = {
  usd: "$",
  rub: "₽",
  kzt: "K",
  eur: "€",
  gbp: "£",
  jpy: "¥",
  cny: "¥",
  try: "₺",
  uah: "₴",
  inr: "₹",
  krw: "₩",
  thb: "฿",
};

function getCurrencySymbol(currencyName: string): string {
  const normalizedName = currencyName.toLowerCase();

  return (
    FIAT_CURRENCY_SYMBOLS[normalizedName] ??
    normalizedName.slice(0, 1).toUpperCase()
  );
}

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    options: {
      type: <PropType<SharedCryptoSelectOption[]>>Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
    isFrom: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    create: null,
    "update:value": null,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    displayedChevronIcon(): string {
      return SVG.chevron;
    },

    displayedPlaceholder(): string {
      return (
        this.options.find((option) => option.id === this.value)?.label ??
        this.placeholder
      );
    },

    displayedCurrency(): SharedCryptoSelectOption | boolean {
      return this.options.find((option) => option.id === this.value) ?? false;
    },

    displayedCurrencySymbol(): string {
      if (typeof this.displayedCurrency !== "object") return "";

      return getCurrencySymbol(this.displayedCurrency.currency.name);
    },
  },
  methods: {
    currencySymbol(currencyName: string): string {
      return getCurrencySymbol(currencyName);
    },

    handleToggle(): void {
      this.isVisible = !this.isVisible;
    },

    handleHide(): void {
      this.isVisible = false;
    },

    handleOption(option: SharedCryptoSelectOption): void {
      this.$emit("update:value", option.id);

      this.handleHide();
    },

    handleCreate(): void {
      this.$emit("create");
    },
  },
});
